/* ===== Supabase Initialization ===== */

import { getSupabaseClient as getSupabaseClientShared } from '@zetyar/supabase-client'
import type { SupabaseClient } from '@supabase/supabase-js'
import { SUPABASE_CONFIG } from '@/config'

export function getSupabaseClient(): SupabaseClient {
  return getSupabaseClientShared(SUPABASE_CONFIG)
}
